/** @hidden */
export const headers = { 'Content-Type': 'application/json' };

/**@hidden */
export const logPrefix = '[Arc AMP SDK]';

/**@hidden */
export const AMP_ID_STORAGE_KEY = 'ArcId.AMP_READER_ID';
